export const message = {
  officialAnswer: "公式の回答",
  answerCheckedMessage: "回答は正常にチェックされました",
  setOfficialAnswerContent: "これを公式の回答に設定してもよろしいですか？",
};
